const baseURL = 'https://api.eunoiatravel.com.ar/api/v1/';
//const baseURL = 'http://localhost:8000/api/v1/';
export { baseURL }